/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBulbRefresh = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m23.914 16-3.707 3.707-1.414-1.414L20.086 17H19a2.5 2.5 0 1 0 2.5 2.5h2A4.5 4.5 0 1 1 19 15h1.086l-1.293-1.293 1.414-1.414z" />
        <path d="M12.003 2C15.888 2 19 5.283 19 9.223c0 1.868-.686 3.772-2.102 5.15l-.006.005-.006.005a2.58 2.58 0 0 0-.231.249l-1.55-1.264c.125-.153.262-.301.41-.44.974-.955 1.484-2.313 1.485-3.705C17 6.318 14.714 4 12.003 4h-.05l-.242.012c-2.49.19-4.583 2.339-4.706 5.023a5.158 5.158 0 0 0 1.445 3.849A5.606 5.606 0 0 1 9.74 15H11v-4h2v4h1v2h-4v1a2 2 0 0 0 2.667 1.887l.666 1.886A4 4 0 0 1 8 18v-1.555c-.043-.76-.377-1.537-.99-2.174a7.158 7.158 0 0 1-2.004-5.326v-.002C5.18 5.181 8.202 2.092 11.903 2z" />
      </g>
    </g>
  </Icon>
);
export { SvgBulbRefresh as BulbRefresh };
